<template>
  <div class="row">
    <div class="col-lg-7">
      <el-card>
        <el-form style="width: 60%;" class="p-2" ref="form" :model="form" :rules="rules" label-position="top">
          <el-form-item label="公司名" prop="name">
            <el-input v-model="form.name"/>
          </el-form-item>
          <el-form-item label="注册资本金" prop="capital">
            <el-input v-model="form.capital">
              <template slot="suffix">万元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="统一社会信用代码" prop="usci">
            <el-input v-model="form.usci"/>
          </el-form-item>
          <el-form-item label="法定代表人" prop="manager">
            <el-input v-model="form.manager"/>
          </el-form-item>
          <el-form-item label="联系人" prop="admin_name">
            <el-input v-model="form.admin_name"/>
          </el-form-item>
          <el-form-item label="联系电话" prop="admin_phone">
            <el-input v-model="form.admin_phone"/>
          </el-form-item>
          <el-form-item>
            <template slot="label">
              <div>
                <span>股权结构
              <el-button type="text" icon="el-icon-plus" @click="form.sharehold.push({name: '', percent: ''})"></el-button></span>
              </div>

            </template>
            <el-row v-for="(sharehold, index) in form.sharehold" :key="index">
              <el-col :span="10">
                <span>股东:<el-input style="width: 60%;" size="small" v-model="form.sharehold[index].name"></el-input></span>
              </el-col>
              <el-col :span="10">
                占股比例:<el-input style="width: 60%;" size="small" v-model="form.sharehold[index].percent">
                <template slot="suffix">%</template>
              </el-input>
              </el-col>
              <el-col :span="2">
                <el-button type="text" icon="el-icon-minus" @click="form.sharehold.splice(index, 1)"></el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-button :loading="loading" type="primary" @click="onSubmit">确认修改</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>

import Layout2 from '../../Shared/Layout2'
import axios from 'axios'

export default {
  layout: Layout2,
  props: {
    company: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      rules: {
        name: [
          {required: true, message: '请输入新公司名称', trigger: 'blur'},
          {min: 6, max: 50, message: '长度在 6 到 50 个字符', trigger: 'blur'},
        ],
        capital: [
          {required: true, message: '请输入注册资本金', trigger: 'blur'},
          {min: 1, max: 50, message: '长度在 6 到 50 个字符', trigger: 'blur'},
        ],
        usci: [
          {required: true, message: '请输入统一社会信用代码', trigger: 'blur'},
          {min: 6, max: 50, message: '长度在 6 到 50 个字符', trigger: 'blur'},
        ],
        admin_name: [
          {required: true, message: '请输入联系人', trigger: 'blur'},
          {min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur'},
        ],
        admin_phone: [
          {required: true, message: '请输入联系电话', trigger: 'blur'},
          {min: 6, max: 50, message: '长度在 6 到 50 个字符', trigger: 'blur'},
        ],
        manager: [
          {required: true, message: '请重复法定代表人', trigger: 'blur'},
          {min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur'},
        ],
      },
      form: {
        id: this.company.id,
        name: this.company.name,
        capital: this.company.capital,
        usci: this.company.usci,
        admin_name: this.company.admin_name,
        admin_phone: this.company.admin_phone,
        manager: this.company.manager,
        license: this.company.license,
        sharehold: this.company.sharehold ? this.company.sharehold : []
      },
    }
  },

  created() {
  },

  methods: {
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          axios.post('/info', this.form).then(res => {
            this.loading = false
            if (res.data.code === 0) {
              this.$message.success('修改成功')
            } else {
              this.$message.error(res.data.message)

            }
          }).catch(err => {
            this.loading = false
          })
        }
      })

    },
  },
}
</script>
